import React from "react";
import { render, unmountComponentAtNode } from "react-dom";

import { AdvancedFilter } from "@multiweb/reactComponents";
import { ElementUtils } from "UI/UI.ElementarControls/Helpers/ElementUtils";
import { registerCustomElement } from "UI/UI.ElementarControls/Utils/CustomElementUtils";
import { IHtmlElementWithResources } from "UI/UI/UI/Controls/ControlInterfaces";

/** Pokročilý filtr pro vkládání TescoTools podmínek */
export class AdvancedFilterEdit extends HTMLElement implements IHtmlElementWithResources {
    // #region Fields
    private _advancedFilterCondition: string;
    private _showAdvancedFilter: boolean = false;
    // #endregion Fields

    // #region Properties
    /** Aktuálně nastavená podmínka pokročilého filtru */
    public get condition(): string {
        return this._advancedFilterCondition;
    }
    // #endregion Properties

    constructor(self?: any) {
        super();
        self ? self._constructor() : this._constructor(); // polyfill
    }

    protected _constructor(): void {
        this.classList.add("input-container");
    }

    // #region Methods
    /**
     * Zobrazí vstup pro pokročilý filtr
     * @param condition Použitá podmínka
     */
    public showFilter(condition?: string): void {
        this._showAdvancedFilter = true;

        if (condition) {
            this._advancedFilterCondition = condition;

            this._createFilter(true);

            return;
        }

        this._createFilter();
    }

    protected connectedCallback(): void {
        this._createFilter();
    }

    /**
     * Vytvoří vstup pro pokročilý filtr
     * @param refresh Překreslí obsah komponenty s novou hodnotou. Nutné při její externí změně
     */
    private async _createFilter(refresh?: boolean): Promise<void> {
        if (!this._showAdvancedFilter) {
            return;
        }

        if (refresh) {
            unmountComponentAtNode(this);
        }

        render(React.createElement(AdvancedFilter, {
            condition: this._advancedFilterCondition,
            onConfirm: (newCondition) => this._conditionConfirmed(newCondition),
            onChange: (newCondition) => this._conditionChanged(newCondition),
            onClose: () => this._closed(),
        }), this);
    }

    /**
     * Nastaví novou uživatelskou podmínku z pokročilého filtru
     * @param condition Uživatelem zadná podmínka
     */
    private _conditionChanged(condition: string): void {
        if (this._advancedFilterCondition !== condition) {
            ElementUtils.callEvent(this, "filterChanged", undefined, false, false);
        }

        this._advancedFilterCondition = condition;
    }

    /**
     * Nastaví novou uživatelskou podmínku z pokročilého filtru a vyvolá událost značící změnu podmínky
     * @param condition Uživatelem zadná podmínka
     */
    private _conditionConfirmed(condition: string): void {
        if (!condition) {
            this._clearAdvancedFilterValue();

            return;
        }

        this._advancedFilterCondition = condition;

        ElementUtils.callEvent(this, "executeFilter", undefined, false, false);
    }

    /** Reaguje na událost zavření pokročilého filtru smazáním jeho hodnoty a odstraněním ze stránky */
    private _closed(): void {
        unmountComponentAtNode(this);

        this._showAdvancedFilter = false;

        this._clearAdvancedFilterValue();
    }

    /** Smaže hodnotu pokročilého filtru a vyvolá událost značící změnu podmínky */
    private _clearAdvancedFilterValue(): void {
        if (this._advancedFilterCondition) {
            this._advancedFilterCondition = null;

            ElementUtils.callEvent(this, "executeFilter", undefined, false, false);
        }
    }

    public dispose(): void {
        unmountComponentAtNode(this);
    }

    // #endregion Methods
}

registerCustomElement("tsc-AdvancedFilterEdit", AdvancedFilterEdit);
